import {ILocalMessage} from '@toolify/client/src/modules/notifications/types/ILocalMessage'
import {IFloatingLocalMessageSyncItem} from '@toolify/client/src/modules/notifications/types/IFloatingLocalMessageSyncItem'
import {MessageActionKindType} from '@toolify/client/src/modules/notifications/enum/MessageActionKindType'

// The card as the notification window draws it: its content and look, no callbacks, routes or keys
export function mapLocalMessageToFloatingSyncItem(message: ILocalMessage): IFloatingLocalMessageSyncItem {
  return {
    id: message.id,
    severity: message.severity,
    title: message.title,
    text: message.text,
    actions: message.actions.map(action => {
      const kind = action.kind ?? MessageActionKindType.Secondary
      return {
        label: action.label,
        kind,
        closes: action.closes !== false,
        navigates: !!action.to || (kind === MessageActionKindType.Link && !!action.href && action.href !== '#'),
        ...(action.dataCy ? {dataCy: action.dataCy} : {}),
      }
    }),
    progress: message.progress ? {...message.progress} : null,
    duration: message.duration,
    dismissible: message.dismissible,
    errorId: message.errorId,
    pinned: message.pinned,
    timerBar: message.timerBar,
    clampLines: message.clampLines,
    showAge: message.showAge,
    count: message.count,
    createdAt: message.createdAt,
  }
}
